var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.80635C0.187595 5.22654 0.580938 5.02376 1.1528 5.02693C7.48865 5.03643 7.17095 5.03327 13.5068 5.03327C13.5976 5.03327 13.6853 5.03327 13.8245 5.03327C13.7247 4.92237 13.6581 4.8495 13.5915 4.77663C12.5991 3.74058 11.6067 2.70452 10.6112 1.67164C10.348 1.39599 10.2602 1.06332 10.3631 0.695786C10.4599 0.334593 10.705 0.106471 11.056 0.024094C11.4009 -0.0551149 11.6914 0.0652827 11.9365 0.32192C12.8351 1.25975 13.7368 2.19759 14.6384 3.13542C15.3101 3.83563 15.9818 4.53267 16.6505 5.23604C17.1165 5.72397 17.1165 6.27526 16.6505 6.76319C15.0862 8.39489 13.5189 10.0266 11.9516 11.6583C11.534 12.0924 10.9743 12.1145 10.5961 11.7153C10.2118 11.3129 10.236 10.7205 10.6596 10.2769C11.6399 9.25035 12.6233 8.22697 13.6067 7.20676C13.6672 7.14339 13.7368 7.0927 13.8003 7.03567C13.7943 7.01349 13.7882 6.99131 13.7821 6.96913C13.6974 6.96913 13.6127 6.96913 13.528 6.96913C7.18306 6.96913 7.4947 6.96596 1.1528 6.97547C0.580938 6.97547 0.187595 6.77586 0 6.19605C0 6.06298 0 5.93308 0 5.80635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogNext);
export default __webpack_public_path__ + "static/media/blog-next.657a1255bd445245d5161e0e0d0f7040.svg";
export { ForwardRef as ReactComponent };